
import { Car } from "@/models/base";
import { AWSFileService } from "@/services/aws-file-service";
import Vue from "vue";
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { CarAwsDocument } from "@/models/base/car-aws-document";

export default Vue.extend({
	data() {
		return {
			sending: false,
		};
	},
	props: {
		car: {
			type: Object as () => Car,
			required: true
		},
	},
	computed: {
		items(): CarAwsDocument[] {
			return this.car.AWSDocuments.filter(f => f.File != null);
		},
		moduleId(): MODULE {
			return MODULE.DOCUMENTENBEHEER;
		},
		hasModule(): boolean {
			return AuthService.hasModule(this.moduleId);
		}
	},
	methods: {
		async download(file: CarAwsDocument) {
			if (!file.File)return;
			await AWSFileService.downloadFile(file.File.Token, file.File.Name);
		},
		upload(){
			this.$emit("upload");
		},
		onFile(file: File) {
			this.car.UnprocessedFiles.push(file);
		},
		removeFile(index: number) {
			this.car.UnprocessedFiles.splice(index, 1);
		},
		removeStoredFile(index:number, file:CarAwsDocument){
			this.car.AWSDocuments.splice(index,1);
			this.car.toDeleteFiles.push(file);
		},
		close() {
			this.$emit("close");
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.aws-documents"
	}
});
